<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="home">
            <defs>
                <path id="gwbt8q4jwa" d="M19.015 9.284l-6.618-5.148c-.234-.181-.56-.181-.794 0L4.985 9.284c-.158.122-.25.31-.25.51v8.089c0 1.167.95 2.117 2.117 2.117h10.296c1.167 0 2.117-.95 2.117-2.117v-8.09c0-.199-.092-.387-.25-.51zm-1.043 8.599c0 .455-.37.824-.824.824H6.852c-.454 0-.824-.37-.824-.824V10.11L12 5.465l5.972 4.645v7.773zm-3.766-6.53H9.794c-.357 0-.646.29-.646.647v7.354c0 .357.289.646.646.646.357 0 .646-.29.646-.646v-6.708h3.12v6.708c0 .357.29.646.646.646.357 0 .646-.29.646-.646V12c0-.357-.289-.646-.646-.646z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="zk0clwr0ub" fill="#fff">
                    <use xlink:href="#gwbt8q4jwa"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#zk0clwr0ub)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-home',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>